import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  CONSULTANT_CCSD_PRICING_RULE_LIST_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_LIST_RECEIVED,
  CONSULTANT_CCSD_PRICING_RULE_LIST_ERROR,
  CONSULTANT_CCSD_PRICING_RULE_LIST_UNLOAD,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_SUCCESS,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATED,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETED,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

// LIST
export const consultantCcsdPricingRuleListRequest = () => ({
  type: CONSULTANT_CCSD_PRICING_RULE_LIST_REQUEST,
});

export const consultantCcsdPricingRuleListReceived = (data) => ({
  type: CONSULTANT_CCSD_PRICING_RULE_LIST_RECEIVED,
  data,
});

export const consultantCcsdPricingRuleListError = (error) => ({
  type: CONSULTANT_CCSD_PRICING_RULE_LIST_ERROR,
  error,
});

export const consultantCcsdPricingRuleListUnload = () => ({
  type: CONSULTANT_CCSD_PRICING_RULE_LIST_UNLOAD,
});

export const consultantCcsdPricingRuleListFetch = (consultantIri) => {
  return (dispatch) => {
    dispatch(consultantCcsdPricingRuleListRequest());
    return requests
      .get(API_ROUTES.CONSULTANT_CCSD_PRICING_RULES, { consultant: consultantIri, pagination: false })
      .then((response) => dispatch(consultantCcsdPricingRuleListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(consultantCcsdPricingRuleListError(error));
      });
  };
};

// CREATE
export const consultantCcsdPricingRuleSingleCreateRequest = () => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_REQUEST,
});

export const consultantCcsdPricingRuleSingleCreateSuccess = (data) => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_SUCCESS,
  data,
});

export const consultantCcsdPricingRuleSingleCreate = (data) => {
  return (dispatch) => {
    dispatch(consultantCcsdPricingRuleSingleCreateRequest());
    return requests
      .post(API_ROUTES.CONSULTANT_CCSD_PRICING_RULES, data)
      .then((response) => {
        dispatch(consultantCcsdPricingRuleSingleCreateSuccess(response));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// UPDATE
export const consultantCcsdPricingRuleSingleUpdateRequest = () => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATE_REQUEST,
});

export const consultantCcsdPricingRuleSingleUpdated = (data) => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATED,
  data,
});

export const consultantCcsdPricingRuleSingleUpdate = (id, data) => {
  return (dispatch) => {
    dispatch(consultantCcsdPricingRuleSingleUpdateRequest());
    return requests
      .patch(`${API_ROUTES.CONSULTANT_CCSD_PRICING_RULES}/${id}`, data)
      .then((response) => {
        dispatch(consultantCcsdPricingRuleSingleUpdated(response));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// DELETE
export const consultantCcsdPricingRuleSingleDeleteRequest = () => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETE_REQUEST,
});

export const consultantCcsdPricingRuleSingleDeleted = (id) => ({
  type: CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETED,
  id,
});

export const consultantCcsdPricingRuleSingleDelete = (id) => {
  return (dispatch) => {
    dispatch(consultantCcsdPricingRuleSingleDeleteRequest());
    return requests
      .delete(`${API_ROUTES.CONSULTANT_CCSD_PRICING_RULES}/${id}`)
      .then(() => {
        dispatch(consultantCcsdPricingRuleSingleDeleted(id));
        return id;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
